import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, Transition as _Transition } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex items-center gap-x-1 leading-normal" }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { class: "text-gray-500" }
const _hoisted_5 = { class: "flex justify-between gap-x-8 px-4 py-5 border-b" }
const _hoisted_6 = { class: "flex flex-col gap-y-1.5" }
const _hoisted_7 = { class: "text-sm font-semibold" }
const _hoisted_8 = { class: "flex items-center gap-x-2" }
const _hoisted_9 = { class: "flex justify-end" }
const _hoisted_10 = {
  key: 0,
  class: "ml-1 text-sm flex-shrink-0 font-medium flex items-center justify-center p-1 rounded-full border border-primary-800 min-w-5 h-5"
}
const _hoisted_11 = {
  role: "tree",
  "aria-orientation": "horizontal",
  class: "relative flex flex-grow divide-x max-h-full overflow-hidden"
}
const _hoisted_12 = {
  class: "flex flex-col items-stretch w-[30%] flex-shrink-0",
  role: "group"
}
const _hoisted_13 = { class: "sticky z-10 top-0 bg-white font-medium text-base border-b px-4 py-2" }
const _hoisted_14 = { class: "max-h-full overflow-y-auto" }
const _hoisted_15 = ["aria-label", "aria-expanded", "aria-setsize", "aria-posinset", "onKeydown", "onMouseover", "onClick"]
const _hoisted_16 = { class: "flex grow gap-x-3 items-center justify-between max-w-full min-w-0" }
const _hoisted_17 = { class: "grow select-none truncate" }
const _hoisted_18 = {
  class: "flex flex-col items-stretch w-[30%] flex-shrink-0",
  role: "group"
}
const _hoisted_19 = { class: "sticky z-10 top-0 bg-white font-medium text-base border-b px-4 py-2" }
const _hoisted_20 = {
  key: 0,
  class: "max-h-full overflow-y-auto"
}
const _hoisted_21 = ["aria-label", "aria-expanded", "aria-setsize", "aria-posinset", "onKeydown", "onMouseover", "onClick"]
const _hoisted_22 = { class: "flex grow gap-x-3 items-center justify-between max-w-full min-w-0" }
const _hoisted_23 = { class: "grow select-none truncate" }
const _hoisted_24 = {
  class: "flex flex-col items-stretch w-[40%] flex-shrink-0",
  role: "group"
}
const _hoisted_25 = { class: "sticky z-10 top-0 bg-white font-medium text-base border-b px-4 py-2" }
const _hoisted_26 = {
  key: 0,
  class: "max-h-full overflow-y-auto"
}
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = { class: "flex gap-x-3 items-center px-3.5 py-3.5 w-full cursor-pointer hover:bg-gray-100/70 focus:bg-gray-100/70 transition-colors" }
const _hoisted_29 = { class: "grow flex items-center justify-between gap-x-2 select-none max-w-full min-w-0" }
const _hoisted_30 = { class: "flex items-center gap-x-1.5 min-w-0" }
const _hoisted_31 = { class: "whitespace-nowrap truncate min-w-0" }
const _hoisted_32 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "shrink-0 size-4 text-yellow-400"
}
const _hoisted_33 = {
  key: 0,
  class: "text-gray-500 text-sm whitespace-nowrap"
}
const _hoisted_34 = {
  key: 1,
  class: "text-gray-500 text-sm whitespace-nowrap"
}
const _hoisted_35 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-white/90"
}
const _hoisted_36 = { class: "flex justify-center items-center gap-2" }
const _hoisted_37 = { class: "text-lg font-medium" }
const _hoisted_38 = { class: "py-3 px-4 border-t" }
const _hoisted_39 = {
  key: 0,
  class: "text-red-500 text-right font-medium"
}
const _hoisted_40 = { class: "pb-4" }
const _hoisted_41 = { class: "flex justify-end" }
const _hoisted_42 = { class: "pt-2" }
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = { class: "text-left font-medium text-gray-400 pl-4 pr-2 pt-2 pb-4" }
const _hoisted_45 = { class: "text-left font-medium text-gray-400 pl-4 pr-2 pt-2 pb-4" }
const _hoisted_46 = { class: "text-left font-medium text-gray-400 pl-4 pr-2 pt-2 pb-4" }
const _hoisted_47 = { class: "text-left font-medium text-gray-400 pl-4 pr-2 pt-2 pb-4" }
const _hoisted_48 = { class: "border border-gray-100" }
const _hoisted_49 = { class: "pl-4 pr-2 py-2" }
const _hoisted_50 = { class: "pl-4 pr-2 py-2" }
const _hoisted_51 = { class: "pl-4 pr-2 py-2" }
const _hoisted_52 = { class: "pl-4 pr-2 py-2" }
const _hoisted_53 = { class: "text-right pl-4 pr-2 py-2" }

import { ref, computed, nextTick } from 'vue';
import { ChevronDown, ChevronRight, Trash2 } from 'lucide-vue-next';
import { parseISO } from 'date-fns';
import cloneDeep from 'lodash-es/cloneDeep';
import { VisuallyHidden } from 'radix-vue';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import CustomCheckbox from '@/components/ui/CustomCheckbox.vue';
import { StudyPeriod } from '@/types';
import { store } from '@/plugins/store';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import TeamsDatePicker from './TeamsDatePicker.vue';
import Spinner from '@/components/ui/Spinner.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import ExpandCollapseTransition from '@/components/common/ExpandCollapseTransition.vue';
import { i18n } from '@/plugins/internationalization/i18n';

interface Props {
    studyPeriods?: StudyPeriod[];
    disabled?: boolean;
    loading?: boolean;
    errorMessage?: string | null;
    displayValue?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamsPicker',
  props: /*@__PURE__*/_mergeModels({
    studyPeriods: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    errorMessage: {},
    displayValue: {}
  }, {
    "selectedStudyPeriods": { required: true },
    "selectedStudyPeriodsModifiers": {},
    "selectedFromDate": { required: true },
    "selectedFromDateModifiers": {},
    "selectedToDate": { required: true },
    "selectedToDateModifiers": {},
  }),
  emits: ["update:selectedStudyPeriods", "update:selectedFromDate", "update:selectedToDate"],
  setup(__props: any) {

const props = __props;

const selectedStudyPeriods = _useModel<number[]>(__props, 'selectedStudyPeriods');
const selectedFromDate = _useModel<string>(__props, 'selectedFromDate');
const selectedToDate = _useModel<string>(__props, 'selectedToDate');

const farms = computed(() => store.state.farms);
const barns = computed(() => store.state.barns);

const options = computed(() => {
    if (!farms.value?.length || !barns.value?.length || !props.studyPeriods?.length) {
        return [];
    }

    const farmOptions: any[] = [];

    for (const farm of farms.value) {
        const barnOptions: any[] = [];

        const farmBarns = barns.value.filter((b) => b.farm_id === farm.farm_id);

        for (const barn of farmBarns) {
            const studyPeriods = props.studyPeriods
                .filter((p) => p.parent_location_id === barn.barn_id)
                .map((p) => ({
                    ...p,
                    checked: selectedStudyPeriods.value.includes(p.id),
                }));

            if (studyPeriods.length) {
                const checked = studyPeriods.every((p) => p.checked);
                const indeterminate = !checked && studyPeriods.some((p) => p.checked);

                barnOptions.push({
                    name: barn.name,
                    id: barn.barn_id,
                    studyPeriods,
                    checked,
                    indeterminate,
                });
            }
        }

        if (barnOptions.length) {
            const checked = barnOptions.every((b) => b.checked);
            const indeterminate = !checked && barnOptions.some((b) => b.checked);

            farmOptions.push({
                name: farm.name,
                id: farm.farm_id,
                barns: barnOptions,
                checked,
                indeterminate,
            });
        }
    }

    return farmOptions;
});

const isTeamsPickerOpen = ref(false);

const selectedActiveFarmIndex = ref<number | null>(null);
const selectedActiveBarnIndex = ref<number | null>(null);

const selectedActiveFarm = computed(() => (selectedActiveFarmIndex.value !== null ? options.value[selectedActiveFarmIndex.value] : null));
const selectedActiveBarn = computed(() =>
    selectedActiveFarmIndex.value !== null && selectedActiveBarnIndex.value !== null ? options.value[selectedActiveFarmIndex.value]?.barns[selectedActiveBarnIndex.value] : null
);

function selectActiveFarm(index: number) {
    selectedActiveFarmIndex.value = index;
    selectedActiveBarnIndex.value = null;
}

function selectActiveBarn(index: number) {
    selectedActiveBarnIndex.value = index;
}

function toggleFarm(farm: any) {
    if (farm.checked) {
        for (const barn of farm.barns) {
            toggleBarn({ ...barn, checked: true });
        }
    } else {
        for (const barn of farm.barns) {
            toggleBarn({ ...barn, checked: false });
        }
    }
}

function toggleBarn(barn: any) {
    const studyPeriodIds = barn.studyPeriods.map((p: any) => p.id);

    if (barn.checked) {
        selectedStudyPeriods.value = selectedStudyPeriods.value.filter((p) => !studyPeriodIds.includes(p));
    } else {
        selectedStudyPeriods.value = [...new Set([...selectedStudyPeriods.value, ...studyPeriodIds])];
    }
}

function toggleStudyPeriod(studyPeriod: any) {
    if (studyPeriod.checked) {
        selectedStudyPeriods.value = selectedStudyPeriods.value.filter((p) => p !== studyPeriod.id);
    } else {
        selectedStudyPeriods.value = [...new Set([...selectedStudyPeriods.value, studyPeriod.id])];
    }
}

const selectedStudyPeriodsToManage = computed<StudyPeriod[]>(() => props.studyPeriods?.filter((p) => selectedStudyPeriods.value.includes(p.id)) ?? []);

const showManageDialog = ref(false);

const studyPeriodsToManage = ref<StudyPeriod[]>([]);

async function openManageDialog() {
    studyPeriodsToManage.value = cloneDeep(selectedStudyPeriodsToManage.value);
    await nextTick();
    showManageDialog.value = true;
}

function removeManageStudyPeriod(optionId: number) {
    studyPeriodsToManage.value = studyPeriodsToManage.value.filter((o) => o.id !== optionId);
}

function saveManageStudyPeriods() {
    selectedStudyPeriods.value = studyPeriodsToManage.value.map((o) => o.id);
    showManageDialog.value = false;
}

const fromDatePickerConfig = computed(() => {
    if (!selectedToDate.value) {
        return {
            maxDate: new Date().toISOString(),
        };
    }

    return {
        maxDate: selectedToDate.value,
    };
});

const activeDisplayValue = computed(() => {
    if (props.displayValue) {
        return props.displayValue;
    }

    return i18n.global.t('views.monitoring.teamComparison.fields.teams.texts.noSelections');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    open: isTeamsPickerOpen.value,
    "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isTeamsPickerOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass(["mt-3 w-full min-h-[46px] flex items-center justify-between gap-x-3 bg-white border rounded-md py-2.5 px-3.5 text-left disabled:opacity-60 disabled:pointer-events-none transition-colors", { 'border-red-500': _ctx.errorMessage }]),
            disabled: _ctx.disabled
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teams.label')) + ":", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(activeDisplayValue.value), 1)
            ]),
            _createVNode(_unref(ChevronDown), {
              class: _normalizeClass(["flex-shrink-0 h-5 w-5 transition-transform", { 'rotate-180': isTeamsPickerOpen.value }]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ], 10, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverContent), {
        "trigger-width": "",
        align: "start",
        class: "flex flex-col p-0 h-[516px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.texts.teamsWithStartDateInPeriod')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TeamsDatePicker, {
                  modelValue: selectedFromDate.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFromDate).value = $event)),
                  config: fromDatePickerConfig.value,
                  prefix: _ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.fields.fromDate.prefix')
                }, null, 8, ["modelValue", "config", "prefix"]),
                _createVNode(TeamsDatePicker, {
                  modelValue: selectedToDate.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedToDate).value = $event)),
                  prefix: _ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.fields.toDate.prefix')
                }, null, 8, ["modelValue", "prefix"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Button), {
                variant: "secondary",
                size: "sm",
                disabled: !selectedStudyPeriodsToManage.value.length || _ctx.loading,
                onClick: openManageDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.categoryPicker.buttons.manageSelected')) + " ", 1),
                  (selectedStudyPeriodsToManage.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(selectedStudyPeriodsToManage.value.length), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teams.groups.farms')), 1),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (farm, farmIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: farm.id,
                    class: "flex items-center cursor-pointer",
                    role: "treeitem",
                    "aria-label": farm.name,
                    "aria-level": "1",
                    "aria-expanded": selectedActiveFarmIndex.value === farmIndex,
                    "aria-setsize": options.value.length,
                    "aria-posinset": farmIndex + 1,
                    tabindex: "0",
                    onKeydown: _withKeys(($event: any) => (selectActiveFarm(farmIndex)), ["enter"]),
                    onMouseover: ($event: any) => (selectActiveFarm(farmIndex)),
                    onClick: ($event: any) => (selectActiveFarm(farmIndex))
                  }, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["flex gap-x-3 items-center px-3.5 py-3.5 w-full cursor-pointer transition-colors", {
                                    'hover:bg-gray-100/70 focus:bg-gray-100/70': selectedActiveFarm.value?.barns?.length && selectedActiveFarmIndex.value !== farmIndex,
                                    'bg-primary-300 bg-opacity-30': selectedActiveFarmIndex.value === farmIndex,
                                }])
                    }, [
                      _createVNode(CustomCheckbox, {
                        checked: farm.checked,
                        indeterminate: farm.indeterminate,
                        "disable-transition": "",
                        class: "flex-shrink-0",
                        "onUpdate:checked": ($event: any) => (toggleFarm(farm))
                      }, null, 8, ["checked", "indeterminate", "onUpdate:checked"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(farm.name), 1),
                        (farm.barns?.length)
                          ? (_openBlock(), _createBlock(_unref(ChevronRight), {
                              key: 0,
                              class: "flex-shrink-0 h-4 w-4 -mr-1"
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ], 2)
                  ], 40, _hoisted_15))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teams.groups.barns')), 1),
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition duration-100 ease-in",
                "leave-from-class": "opacity-0",
                "leave-to-class": "opacity-0"
              }, {
                default: _withCtx(() => [
                  (selectedActiveFarm.value?.barns?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedActiveFarm.value?.barns, (barn, barnIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: barn.id,
                            role: "treeitem",
                            "aria-label": barn.name,
                            "aria-level": "2",
                            "aria-expanded": selectedActiveBarnIndex.value === barnIndex,
                            "aria-setsize": selectedActiveFarm.value?.barns.length,
                            "aria-posinset": barnIndex + 1,
                            class: "flex items-center cursor-pointer",
                            tabindex: "0",
                            onKeydown: _withKeys(($event: any) => (selectActiveBarn(barnIndex)), ["enter"]),
                            onMouseover: ($event: any) => (selectActiveBarn(barnIndex)),
                            onClick: ($event: any) => (selectActiveBarn(barnIndex))
                          }, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["flex gap-x-3 items-center px-3.5 py-3.5 w-full cursor-pointer transition-colors", {
                                        'hover:bg-gray-100/70 focus:bg-gray-100/70': barn.studyPeriods?.length && selectedActiveBarnIndex.value !== barnIndex,
                                        'bg-primary-300 bg-opacity-30': selectedActiveBarnIndex.value === barnIndex,
                                    }])
                            }, [
                              _createVNode(CustomCheckbox, {
                                checked: barn.checked,
                                indeterminate: barn.indeterminate,
                                "disable-transition": "",
                                class: "flex-shrink-0",
                                "onUpdate:checked": ($event: any) => (toggleBarn(barn))
                              }, null, 8, ["checked", "indeterminate", "onUpdate:checked"]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(barn.name), 1),
                                (barn.studyPeriods?.length)
                                  ? (_openBlock(), _createBlock(_unref(ChevronRight), {
                                      key: 0,
                                      class: "flex-shrink-0 h-4 w-4 -mr-1"
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ], 40, _hoisted_21))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teams.groups.teams')), 1),
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-active-class": "transition duration-100 ease-in",
                "leave-from-class": "opacity-0",
                "leave-to-class": "opacity-0",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (selectedActiveBarn.value?.studyPeriods.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedActiveBarn.value.studyPeriods, (studyPeriod) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: studyPeriod.id,
                            role: "treeitem",
                            "aria-label": studyPeriod.name,
                            "aria-level": "3",
                            class: "flex items-center cursor-pointer",
                            tabindex: "0"
                          }, [
                            _createElementVNode("label", _hoisted_28, [
                              _createVNode(CustomCheckbox, {
                                checked: studyPeriod.checked,
                                "disable-transition": "",
                                class: "flex-shrink-0",
                                "onUpdate:checked": ($event: any) => (toggleStudyPeriod(studyPeriod))
                              }, null, 8, ["checked", "onUpdate:checked"]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(studyPeriod.name), 1),
                                  (studyPeriod.is_favorite)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[5] || (_cache[5] = [
                                        _createElementVNode("path", {
                                          "fill-rule": "evenodd",
                                          d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
                                          "clip-rule": "evenodd"
                                        }, null, -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ]),
                                (studyPeriod.start && studyPeriod.end)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$d(_unref(parseISO)(studyPeriod.start as string), 'short')) + _toDisplayString(studyPeriod.end ? ` - ${_ctx.$d(_unref(parseISO)(studyPeriod.end as string), 'short')}` : ''), 1))
                                  : (studyPeriod.start)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$d(_unref(parseISO)(studyPeriod.start as string), 'short')), 1))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ], 8, _hoisted_27))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createVNode(FadeTransition, null, {
              default: _withCtx(() => [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.texts.loading')), 1),
                        _createVNode(Spinner, { class: "w-6 h-6 animate-spin" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(ExpandCollapseTransition, null, {
              default: _withCtx(() => [
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.errorMessage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_unref(Button), {
                class: "w-44",
                disabled: !!_ctx.errorMessage,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isTeamsPickerOpen.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.buttons.saveSelected')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createVNode(_unref(Dialog), {
            modelValue: showManageDialog.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showManageDialog).value = $event)),
            class: "sm:max-w-[960px]"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.title')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(VisuallyHidden), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogDescription), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.description')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("table", _hoisted_43, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.table.headers.name')), 1),
                      _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.table.headers.start')), 1),
                      _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.table.headers.end')), 1),
                      _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.table.headers.location')), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studyPeriodsToManage.value, (studyPeriod) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: studyPeriod.id,
                        class: "odd:bg-gray-100"
                      }, [
                        _createElementVNode("td", _hoisted_49, _toDisplayString(studyPeriod.name), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.$d(_unref(parseISO)(studyPeriod.start as string), 'short')), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.$d(_unref(parseISO)(studyPeriod.end as string), 'short')), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(studyPeriod.location_name_augmented), 1),
                        _createElementVNode("td", _hoisted_53, [
                          _createVNode(_unref(Button), {
                            variant: "ghost",
                            size: "icon",
                            class: "text-red-500 hover:text-red-600 hover:bg-red-100",
                            onClick: ($event: any) => (removeManageStudyPeriod(studyPeriod.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode(_unref(DialogFooter), { class: "flex sm:justify-center pt-2" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogClose), { "as-child": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "ghost",
                        size: "lg",
                        class: "min-w-44"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.buttons.cancel')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    size: "lg",
                    class: "min-w-44",
                    onClick: saveManageStudyPeriods
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.fields.teamsPicker.dialogs.manageSelected.buttons.save')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})